import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

interface Breadcrumb {
  label: string;
  href?: string;
}

interface PageTitleBarProps {
  title: string;
  breadcrumbs: Breadcrumb[];
  actionLabel?: string;
  actionHref?: string;
}

export const PageTitleBar: React.FC<PageTitleBarProps> = ({
  title,
  breadcrumbs,
  actionLabel,
  actionHref,
}) => (
  <div className="flex justify-between items-center mb-6">
    <div>
      <h1 className="text-2xl font-bold text-panagora-deep-blue">{title}</h1>
      <div className="flex items-center text-sm text-gray-500">
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={index}>
            {breadcrumb.href ? (
              <Link to={breadcrumb.href} className="hover:text-[#3eaf99]">
                {breadcrumb.label}
              </Link>
            ) : (
              <span className="font-medium text-panagora-deep-blue">{breadcrumb.label}</span>
            )}
            {index < breadcrumbs.length - 1 && (
              <ChevronRight className="h-4 w-4 mx-1" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
    {actionLabel && actionHref && (
      <Link to={actionHref}>
        <Button className="bg-teal-500 hover:bg-teal-400 text-white rounded-md px-6 py-2">
          <span className="font-semibold">{actionLabel}</span>
        </Button>
      </Link>
    )}
  </div>
);
